/*
  Plays PDP gallery walk-on videos (snippets/pmx-gallery-video.liquid) only while they are
  on screen. The <video> has preload="none" and no autoplay, so nothing is fetched until
  its carousel slide is at least half visible. Off-screen or hidden slides pause.
  prefers-reduced-motion: never plays; the poster frame stays.
*/
(() => {
  if (window.__pmxGalleryVideo) return;
  window.__pmxGalleryVideo = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const SELECTOR = 'video.pmx-gallery-video__el';

  const play = (video) => {
    if (reduceMotion.matches) return;
    video.muted = true;
    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SELECTOR).forEach(play);
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          play(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { threshold: [0, 0.5] }
  );

  const observeAll = () => {
    document.querySelectorAll(`${SELECTOR}:not([data-pmx-observed])`).forEach((video) => {
      video.dataset.pmxObserved = '1';
      io.observe(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }
  document.addEventListener('shopify:section:load', observeAll);
  document.addEventListener('pmx:pdp-variant-rendered', observeAll);

  // The in-place variant switch (sections/main-product.liquid) swaps the gallery,
  // and the carousel re-creates its slides as it mounts, so a walk-on video can be
  // replaced by a fresh element after any event fires. Pick up new ones as they appear.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; observeAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
